import { formatDate } from '@angular/common';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_426 implements Validator {

    public static id = 'CTRL_426';
    private message = 'error.ctr_426';


    public LOG: LogService = new LogService(CTRL_426);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_426.id + '_');


        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const dateAttributionNameWithStepId = map.get(ctrl.value.rgCtrls.dateAttribution);
                
                const dateAttributionCtrl = form.controls[dateAttributionNameWithStepId];
                const datePublication = ctrl.value.rgCtrls.datePublication;
                if (datePublication !== null && datePublication !== 'yyyy-MM-dd' && datePublication !== '' && dateAttributionCtrl !== undefined && dateAttributionCtrl.value.split('T')[0] < datePublication.split('T')[0]) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}
